import { IconChevronDownSmallOutline, IconChevronRightSmallOutline } from '@teamleader/ahoy';
import { translate } from '@teamleader/i18n';
import cx from 'classnames';
import React, { useCallback, useContext, useState } from 'react';

import styles from './styles.css';
import Box from '../../../../../Components/UI/Box';
import { apiFormatDate, fromISO } from '../../../../../Utils/date';
import { ProjectContext } from '../../../Context';

const InvoiceDetails: React.FC = () => {
  const { project, department } = useContext(ProjectContext);
  const [isOpen, setIsOpen] = useState(true);
  const toggleMenu = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const Icon = isOpen ? IconChevronDownSmallOutline : IconChevronRightSmallOutline;

  if (!project || !department) {
    return null;
  }

  if (!project.startDate && !project.endDate) {
    return null;
  }

  return (
    <Box className={styles['project-details']}>
      <Box className={styles['project-details-header']} onClick={toggleMenu}>
        <Icon />
        <h4>{translate('projectInfo.title')}</h4>
      </Box>
      {isOpen && (
        <Box className={styles['project-details-body']}>
          <Box className={styles['project-details-wrapper']}>
            {project.startDate && (
              <Box className={cx(styles['project-details-label-value'], styles['project-details-label-value--bold'])}>
                <Box className={styles['project-details-label']}>{translate('startDate')}</Box>
                <Box className={styles['project-details-value']}>
                  {apiFormatDate(fromISO(project.startDate), department.dateFormat)}
                </Box>
              </Box>
            )}
            {project.endDate && (
              <Box className={cx(styles['project-details-label-value'], styles['project-details-label-value--bold'])}>
                <Box className={styles['project-details-label']}>{translate('endDate')}</Box>
                <Box className={styles['project-details-value']}>
                  {apiFormatDate(fromISO(project.endDate), department.dateFormat)}
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default InvoiceDetails;
